import React, { useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Drawer, Hidden, Paper } from '@material-ui/core';
import { Navigation } from '../index';
import { useRouter } from '../../utils';
import useStyles from './styles';
import { createStructuredSelector } from 'reselect';
import { getUserSelector, isLoggedInSelector, menuItemsSelector } from '../../appContainer/selectors';
import { useSelector } from 'react-redux';

const stateSelector = createStructuredSelector({
  loggedInUser: getUserSelector,
  menuItems: menuItemsSelector,
  isLoggedIn: isLoggedInSelector,
});

const NavBar = props => {
  const { openMobile, onMobileClose, className, ...rest } = props;

  const classes = useStyles();
  const router = useRouter();
  const { menuItems } = useSelector(stateSelector);

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [router.location.pathname]);

  console.log(router.location.pathname)

  const navbarContent = (
    <div className={classes.content}>
      <nav className={classes.navigation}>
        {menuItems.map(list => (
          <Navigation key={list.title} component="div" pages={list.pages} title={list.title} titleId={list.titleId} handleClick={onMobileClose}/>
        ))}
      </nav>
    </div>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer anchor="left" onClose={onMobileClose} open={openMobile} variant="temporary">
          <div {...rest} className={clsx(classes.root, className)}>
            {navbarContent}
          </div>
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Paper {...rest} className={clsx(classes.root, className)} elevation={1} square>
          {navbarContent}
        </Paper>
      </Hidden>
    </>
  );
};

NavBar.propTypes = {
  className: PropTypes.string,
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
};

export default NavBar;
